import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Box,
  Button,
  Tabs,
  Tab,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Tooltip,
  Paper,
  AppBar
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import MUIDataTable, {
  MUIDataTableColumnOptions,
  MUIDataTableMeta,
  SelectableRows
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import _ from 'lodash';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import NumberFormat from 'react-number-format';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import MaterialTable from 'material-table';
import { getLocalization, MaterialTableIcons } from '../../_shared/TableSettings';
import { CloudUploadOutlined } from '@material-ui/icons';
import {
  ImportStockPartAttachment,
  StockPart,
  StockPartImportedDto,
  StockPartImportRequestDto
} from '../../../interfaces/Case';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import { Autocomplete } from '@material-ui/lab';
import { IReferential } from '../../../interfaces/IReferential';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import { ReferentialCode } from '../../../helpers/Constants';
import * as R from 'ramda';
import Referentials from '../../../helpers/Referentials.json';
import { OrganizationInfoDto } from '../../../interfaces/Organization';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';

interface IStockPartState {
  stockParts: StockPart[];
  organizationId: number;
  carPartCategories: IReferential[];
  isLoading: boolean;
  newStockPart: StockPart;
  newStockPartId: number | null;
  isDialogOpen: boolean;
  isLoadingImportData: boolean;
  isImportDialogOpen: boolean;
  attachments: ImportStockPartAttachment[];
  importedStockPartList: StockPartImportedDto[];
}

type IStockPartProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string }>;

class StockPartComponent extends React.PureComponent<IStockPartProps, IStockPartState> {
  private translatorService!: ITranslatorService;
  private appReferentialService!: IReferentialService;
  private caseService!: ICaseService;
  private organizationService!: IOrganizationService;

  static contextType = ApplicationContext;
  private newStockPart = {
    id: 0
  } as StockPart;

  state = {
    stockParts: [],
    suppliers: [],
    organizationId: this.props.appState.appUser!.organizationId,
    carPartCategories: [],
    isLoading: false,
    newStockPart: this.newStockPart,
    newStockPartId: null,
    isDialogOpen: false,
    isLoadingImportData: false,
    isImportDialogOpen: false,
    attachments: [],
    importedStockPartList: []
  } as IStockPartState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  loadData = async () => {
    const carPartCategoryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.CarPartCategory
    );
    const [stockParts, carPartCategories] = await Promise.all([
      this.caseService.StockPartList(this.state.organizationId),
      this.appReferentialService.Get(carPartCategoryRef!.baseUrl)
    ]);

    stockParts.forEach((item) => {
      const alternativePartQuality = carPartCategories.find(
        (categoryItem) =>
          !R.isNil(item.alternativePartQualityId) &&
          categoryItem.id === item.alternativePartQualityId
      );
      item.alternativePartQuality = R.isNil(alternativePartQuality) ? null : alternativePartQuality;
    });

    this.setState({
      stockParts: stockParts,
      carPartCategories: carPartCategories,
      isLoading: false
    });
  };

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };

  public saveStockPart = async () => {
    if (this.state.newStockPartId === null) {
      try {
        await this.caseService.AddStockPart({
          ...this.state.newStockPart,
          organizationId: this.state.organizationId
        });

        await this.loadData();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.caseService.UpdateStockPart({
          ...this.state.newStockPart,
          organizationId: this.state.organizationId
        });

        await this.loadData();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  NumberFormatInteger = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={0}
      />
    );
  };

  private handleAlternativePartQualityChange = (newValue: IReferential | null) => {
    this.setState({
      newStockPart: {
        ...this.state.newStockPart,
        alternativePartQuality: newValue,
        alternativePartQualityId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handlePriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newStockPart: {
        ...this.state.newStockPart,
        alternativePrice: event.target.value === null ? 0 : parseFloat(event.target.value)
      }
    });
  };

  private handleAvailableQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newStockPart: {
        ...this.state.newStockPart,
        availableQuantity: event.target.value === null ? 0 : parseInt(event.target.value)
      }
    });
  };

  onChange = (fieldName: string, isNumber: boolean) => (e: any, newValue?: IReferential | null) => {
    isNumber
      ? this.setState({
          newStockPart: {
            ...this.state.newStockPart,
            [fieldName]: parseFloat(newValue || e.target.value)
          }
        })
      : this.setState({
          newStockPart: {
            ...this.state.newStockPart,
            [fieldName]: newValue || e.target.value
          }
        });
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveStockPart} instantValidate={true}>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              id="guideNumber"
              className="m-2 pr-3"
              name="guideNumber"
              placeholder={this.translatorService.Tranlate('STOCK_PART_GUIDE_NUMBER', 'Cod O.E')}
              label={this.translatorService.Tranlate('STOCK_PART_GUIDE_NUMBER', 'Cod O.E')}
              value={this.state.newStockPart.guideNumber || ''}
              onChange={(e: any) => this.onChange('guideNumber', false)(e)}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              id="alternativeGuideNumber"
              className="m-2 pr-3"
              name="alternativeGuideNumber"
              placeholder={this.translatorService.Tranlate('STOCK_PART_ALT_GUIDE_NUMBER', 'Cod AM')}
              label={this.translatorService.Tranlate('STOCK_PART_ALT_GUIDE_NUMBER', 'Cod AM')}
              value={this.state.newStockPart.alternativeGuideNumber || ''}
              onChange={(e: any) => this.onChange('alternativeGuideNumber', false)(e)}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              id="alternativePartName"
              className="m-2 pr-3"
              name="alternativePartName"
              placeholder={this.translatorService.Tranlate('STOCK_PART_NAME', 'Denumire')}
              label={this.translatorService.Tranlate('STOCK_PART_NAME', 'Denumire')}
              value={this.state.newStockPart.alternativePartName || ''}
              onChange={(e: any) => this.onChange('alternativePartName', false)(e)}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              name="alternativePrice"
              className="m-2 pr-3"
              id="alternativePrice"
              value={this.state.newStockPart.alternativePrice ?? ''}
              onChange={this.handlePriceChange}
              label={this.translatorService.Tranlate('STOCK_PART_PRICE', 'Pret')}
              validators={['required', 'minNumber:0']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
                this.translatorService.Tranlate(
                  'STOCK_PART_PRICE_VALIDATORS_NUMBER_NOT_ZERO',
                  'Pretul trebuie sa fie mai mare ca 0'
                )
              ]}
              InputProps={{
                inputComponent: this.NumberFormatCustom
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="alternativePartQuality"
              className="m-2 pr-3"
              fullWidth
              options={this.state.carPartCategories}
              value={this.state.newStockPart.alternativePartQuality}
              onChange={(e: any, newValue: IReferential | null) =>
                this.handleAlternativePartQualityChange(newValue)
              }
              getOptionLabel={(option: IReferential) => option.displayName || ''}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name="alternativePartQuality"
                  value={this.state.newStockPart.alternativePartQuality || ''}
                  label={this.translatorService.Tranlate('STOCK_PART_QUALITY', 'Calitate')}
                  fullWidth
                  validators={['required']}
                  errorMessages={[
                    this.translatorService.Tranlate(
                      'VALIDATORS_REQUIRED',
                      'Campul este obligatoriu'
                    )
                  ]}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              id="deliveryTime"
              className="m-2 pr-3"
              name="deliveryTime"
              placeholder={this.translatorService.Tranlate('STOCK_PART_DELIVERY', 'Livrare')}
              label={this.translatorService.Tranlate('STOCK_PART_DELIVERY', 'Livrare')}
              value={this.state.newStockPart.deliveryTime || ''}
              onChange={(e: any) => this.onChange('deliveryTime', false)(e)}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              id="producer"
              className="m-2 pr-3"
              name="producer"
              placeholder={this.translatorService.Tranlate('STOCK_PART_PRODUCER', 'Producator')}
              label={this.translatorService.Tranlate('STOCK_PART_PRODUCER', 'Producator')}
              value={this.state.newStockPart.producer || ''}
              onChange={(e: any) => this.onChange('producer', false)(e)}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              id="supplierName"
              className="m-2 pr-3"
              name="supplierName"
              placeholder={this.translatorService.Tranlate('STOCK_PART_SUPPLIER', 'Furnizor')}
              label={this.translatorService.Tranlate('STOCK_PART_SUPPLIER', 'Furnizor')}
              value={this.state.newStockPart.supplierName || ''}
              onChange={(e: any) => this.onChange('supplierName', false)(e)}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              name="availableQuantity"
              className="m-2 pr-3"
              id="availableQuantity"
              value={this.state.newStockPart.availableQuantity ?? ''}
              onChange={this.handleAvailableQuantityChange}
              label={this.translatorService.Tranlate('STOCK_PART_QTY', 'Cant.')}
              InputProps={{
                inputComponent: this.NumberFormatInteger
              }}
              validators={['required', 'minNumber:0']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
                this.translatorService.Tranlate(
                  'STOCK_PART_QTY_VALIDATORS_NUMBER_GREATER_THAN_ZERO',
                  'Cantitatea trebuie sa fie mai mare sau egala cu 0'
                )
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextValidator
              fullWidth
              id="alternativePartStockLocation"
              className="m-2 pr-3"
              name="alternativePartStockLocation"
              placeholder={this.translatorService.Tranlate('STOCK_PART_LOCATION', 'Locatie')}
              label={this.translatorService.Tranlate('STOCK_PART_LOCATION', 'Locatie')}
              value={this.state.newStockPart.alternativePartStockLocation || ''}
              onChange={(e: any) => this.onChange('alternativePartStockLocation', false)(e)}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
        </Grid>

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: {
          display: 'excluded',
          filter: false
        } as MUIDataTableColumnOptions
      },
      {
        name: 'guideNumber',
        label: this.translatorService.Tranlate('STOCK_PART_GUIDE_NUMBER', 'Cod O.E')
      },
      {
        name: 'alternativeGuideNumber',
        label: this.translatorService.Tranlate('STOCK_PART_ALT_GUIDE_NUMBER', 'Cod AM')
      },
      {
        name: 'alternativePartName',
        label: this.translatorService.Tranlate('STOCK_PART_NAME', 'Denumire')
      },
      {
        name: 'alternativePrice',
        label: this.translatorService.Tranlate('STOCK_PART_PRICE', 'Pret')
      },
      {
        name: 'alternativePartQuality',
        label: this.translatorService.Tranlate('STOCK_PART_QUALITY', 'Calitate'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.name!.localeCompare(b.displayName!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'deliveryTime',
        label: this.translatorService.Tranlate('STOCK_PART_DELIVERY', 'Livrare')
      },
      {
        name: 'producer',
        label: this.translatorService.Tranlate('STOCK_PART_PRODUCER', 'Producator')
      },
      {
        name: 'supplierName',
        label: this.translatorService.Tranlate('STOCK_PART_SUPPLIER', 'Furnizor')
      },
      {
        name: 'availableQuantity',
        label: this.translatorService.Tranlate('STOCK_PART_QTY', 'Cant.')
      },
      {
        name: 'alternativePartStockLocation',
        label: this.translatorService.Tranlate('STOCK_PART_LOCATION', 'Locatie')
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (_: any, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={() => this.newStockPartPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteStockPart(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];

    return columns;
  };

  deleteStockPart = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.caseService.RemoveStockPart(id);

      await this.loadData();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newStockPartPopup = async (stockPartId: number | null) => {
    let stockPart: StockPart;
    if (stockPartId == null) {
      stockPart = { ...this.state.newStockPart } as StockPart;
    } else {
      stockPart = this.state.stockParts.find((item) => item.id === stockPartId)!;
    }

    this.setState({
      isDialogOpen: true,
      newStockPart: stockPart,
      newStockPartId: stockPartId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      newStockPart: this.newStockPart,
      newStockPartId: null
    });
  };

  openImportDialog = async () => {
    this.setState({
      isImportDialogOpen: true,
      isLoadingImportData: false,
      attachments: [],
      importedStockPartList: []
    });
  };

  closeImportDialog = async () => {
    this.setState(
      {
        isImportDialogOpen: false,
        isLoading: true,
        importedStockPartList: [],
        attachments: []
      },
      async () => {
        await this.loadData();
      }
    );
  };

  handleDeleteAttachment = async (id: number, fileName: string) => {
    try {
      const attachments = [...this.state.attachments];
      const index = attachments.findIndex((item) => item.id === id);
      attachments.splice(index, 1);

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  canUpload = (): boolean => {
    const files = this.state.attachments;

    if (files.length >= 1) {
      return false;
    }

    return true;
  };

  handleUploadAttachment = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const attachments = [...this.state.attachments];
      attachments.push({
        id: 0,
        file: e.target.files![0],
        fileName: e.target.files![0].name,
        uploadDate: new Date(),
        originalFileName: e.target.files![0].name
      });
      e.target.value = '';

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderAttachmentBox = () => {
    return (
      <Grid container spacing={2} className="mt-2 mb-5">
        <Grid item xs={9}>
          {this.state.attachments.length !== 0
            ? this.state.attachments.map((attach, index) => {
                return (
                  <div key={index} className="d-flex flex-row w-100">
                    <div className="w-75 text-left">
                      <Button
                        color="primary"
                        className="text-primary text-left pl-0"
                        disabled={false}
                        onClick={(e) => {
                          console.log('download');
                        }}
                      >
                        <span className="crop">{attach.originalFileName}</span>
                      </Button>
                    </div>
                    <div className="w-25">
                      <IconButton
                        aria-label="delete"
                        color="inherit"
                        className="text-danger"
                        size="small"
                        onClick={(e) => {
                          this.handleDeleteAttachment(attach.id, attach.fileName);
                        }}
                        disabled={false}
                      >
                        <DeleteOutlineTwoToneIcon />
                      </IconButton>
                    </div>
                  </div>
                );
              })
            : null}
        </Grid>
        <Grid item xs={3} container justify="flex-end" direction="column">
          <Button
            variant="outlined"
            size="small"
            color="primary"
            className="d-block text-center shadow-none"
            component="div"
            disabled={!this.canUpload()}
          >
            <input
              accept=".xls, .xlsx"
              className="d-none"
              id={'contained-button-file'}
              onChange={(e) => {
                return this.handleUploadAttachment(e);
              }}
              type="file"
              disabled={!this.canUpload()}
            />
            <label htmlFor={'contained-button-file'} className="w-100 mb-0">
              {this.translatorService.Tranlate(
                'MAVO_VEHICLES_UPLOAD_FILE_BTN_LABEL',
                'Uploadeaza fisier'
              )}
            </label>
          </Button>
        </Grid>
      </Grid>
    );
  };

  handleImport = async () => {
    if (this.state.attachments.length === 0) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'ERROR_MSG_FILE_NOT_SELECTED',
          'Va rugam sa selectati un fisier!'
        ),
        {
          variant: 'error'
        }
      );
      return;
    }
    this.setState({
      isLoadingImportData: true
    });

    const request = {
      attachments: this.state.attachments,
      organizationId: this.state.organizationId
    } as StockPartImportRequestDto;

    try {
      const result = await this.caseService.ImportStockParts(request);
      this.props.enqueueSnackbar(
        <div>
          <p>
            {this.translatorService.Tranlate('ORGANIZATION_PART_DATA_PROCESSED', 'Date tratate: ')}{' '}
            {result.totalNumber}
          </p>
          <p>
            {this.translatorService.Tranlate(
              'ORGANIZATION_PART_TREATED_SUCCESSFULLY',
              'Tratate cu succes: '
            )}{' '}
            {result.importedNumber}
          </p>
        </div>,
        {
          variant: 'info',
          autoHideDuration: 6000
        }
      );
      this.setState({
        importedStockPartList: result.stockPartList,
        isLoadingImportData: false
      });
    } catch {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error',
        autoHideDuration: 6000
      });
      this.setState({
        isLoadingImportData: false
      });
    }
  };

  getImportedColumns = () => {
    return [
      {
        field: 'guideNumber',
        title: this.translatorService.Tranlate('STOCK_PART_GUIDE_NUMBER', 'Cod O.E')
      },
      {
        field: 'alternativeGuideNumber',
        title: this.translatorService.Tranlate('STOCK_PART_ALT_GUIDE_NUMBER', 'Cod AM')
      },
      {
        field: 'alternativePartName',
        title: this.translatorService.Tranlate('STOCK_PART_NAME', 'Denumire')
      },
      {
        field: 'alternativePrice',
        title: this.translatorService.Tranlate('STOCK_PART_PRICE', 'Pret')
      },
      {
        field: 'alternativePartQuality',
        title: this.translatorService.Tranlate('STOCK_PART_QUALITY', 'Calitate')
      },
      {
        field: 'deliveryTime',
        title: this.translatorService.Tranlate('STOCK_PART_DELIVERY', 'Livrare')
      },
      {
        field: 'producer',
        title: this.translatorService.Tranlate('STOCK_PART_PRODUCER', 'Producator')
      },
      {
        field: 'supplierName',
        title: this.translatorService.Tranlate('STOCK_PART_SUPPLIER', 'Furnizor')
      },
      {
        field: 'availableQuantity',
        title: this.translatorService.Tranlate('STOCK_PART_QTY', 'Cant.')
      },
      {
        field: 'alternativePartStockLocation',
        title: this.translatorService.Tranlate('STOCK_PART_LOCATION', 'Locatie')
      },
      {
        field: 'importMessage',
        title: this.translatorService.Tranlate(
          'MAVO_VEHICLES_VEHICLE_IMPORT_MESSAGE',
          'Mesaj import'
        ),
        render: (rowData: StockPartImportedDto) => {
          return this.translatorService.Tranlate(rowData.importMessage, rowData.importMessage);
        }
      }
    ];
  };

  renderImportedResultBox = () => {
    return this.state.importedStockPartList.length > 0 ? (
      <MaterialTable
        columns={this.getImportedColumns()}
        data={this.state.importedStockPartList}
        title=""
        icons={MaterialTableIcons}
        localization={getLocalization(this.translatorService)}
        options={{
          actionsColumnIndex: -1,
          addRowPosition: 'first',
          maxBodyHeight: 400,
          paging: false,
          sorting: false,
          search: false
        }}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />
        }}
      />
    ) : (
      ''
    );
  };

  public renderImportContent() {
    return (
      <ValidatorForm onSubmit={this.handleImport} instantValidate={true}>
        {this.renderAttachmentBox()}
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingImportData} />
        </div>
        {this.renderImportedResultBox()}
        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeImportDialog}
          >
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_CLOSE_BTN', 'Renunta')}
          </Button>
          <Button
            className="m-2"
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.state.isLoadingImportData}
          >
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_BTN', 'Importa')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.caseService = (this.context as AppContext).caseService;
    this.organizationService = (this.context as AppContext).organizationService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      customToolbar: () => {
        return (
          <div>
            <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
              <IconButton
                aria-label="add"
                color="secondary"
                className="m-2"
                onClick={(e) => this.newStockPartPopup(null)}
              >
                <AddCircleTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.translatorService.Tranlate('Import', 'Importa')}>
              <IconButton
                aria-label="import"
                color="primary"
                className="m-2"
                onClick={(e) => this.openImportDialog()}
              >
                <CloudUploadOutlined />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <AppBar position="static" elevation={0} color="secondary">
          <Tabs
            TabIndicatorProps={{
              style: {
                height: '4px'
              }
            }}
            value={0}
            onChange={undefined}
            variant="fullWidth"
            centered={true}
            indicatorColor="primary"
            aria-label="simple tabs example"
          >
            <Tab
              label={this.translatorService.Tranlate(
                'MENU_SETTINGS_TAB_STOCK_PART',
                'Piese stoc propriu'
              )}
            />
          </Tabs>
        </AppBar>
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
        </div>
        {!this.state.isLoading ? (
          <MUIDataTable
            title={''}
            data={this.state.stockParts}
            columns={this.getColumns()}
            options={options}
          />
        ) : null}
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullScreen={false}
            fullWidth={true}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography className="MuiTypography-h4">
                    {!this.state.newStockPartId
                      ? this.translatorService.Tranlate(
                          'STOCK_PART_NEW_MODAL_TITLE',
                          'Adauga piesa stoc propriu'
                        )
                      : this.translatorService.Tranlate(
                          'STOCK_PART_EDIT_MODAL_TITLE',
                          'Actualizeaza piesa stoc propriu'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : (
          ''
        )}

        {this.state.isImportDialogOpen ? (
          <Dialog
            onClose={this.closeImportDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isImportDialogOpen}
            fullScreen={true}
            fullWidth={true}
          >
            <DialogTitle
              id="customized-dialog-title"
              style={{
                color: '#ffffff',
                backgroundColor: 'var(--primary)',
                textAlign: 'center'
              }}
            >
              <span style={{ fontSize: '20px', lineHeight: '24px' }}>
                {this.translatorService.Tranlate(
                  'ORGANIZATION_PART_IMPORT_MODAL_TITLE',
                  'Importa piese'
                )}
              </span>
              <IconButton
                aria-label="close"
                className="position-absolute"
                style={{ right: 12, top: 12, color: '#ffffff' }}
                onClick={this.closeImportDialog}
                size={'small'}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Box m={1} p={1}>
                {this.renderImportContent()}
              </Box>
            </DialogContent>
          </Dialog>
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(StockPartComponent as any));
